import React, { useEffect, useState } from "react";
import { MdOutlineFilterList } from "react-icons/md";
import { Col, Row } from "react-bootstrap";
import axios from "axios";
import { ApiPaths } from "../../Config/ApiPath";
import Loader from "../../Components/Loader/Loader";
import { GrNext, GrPrevious } from "react-icons/gr";
import liveRate from "../../Common/LiveRate";
import useAxiosHelper from "../../Common/AxiosHelper";
import { setIncomeWallet } from "../../Redux/IncomeWallet";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../Components/PaginationControls/PaginationControls";
import { BasicInfo } from "../../Config/BasicInfo";
import moment from "moment";

const IncomeTabs = ({ incomeWallets, selectIncome, setSelectIncome }) => {
  return (
    <div className="incomeTabs">
      {Array.isArray(incomeWallets) &&
        incomeWallets.map((x) => (
          <button
            key={x?.slug}
            className={`incomeTabButton ${
              selectIncome === x?.slug ? "active" : ""
            }`}
            onClick={() => setSelectIncome(x?.slug)}
          >
            {x?.name}
          </button>
        ))}
    </div>
  );
};

const LegBusiness = () => {
  const { AxiosGet, AxiosPost } = useAxiosHelper();
  const dispatch = useDispatch();
  const [filterVisiblity, setFilterVisiblity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [initValue, setInitValue] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [limitFilter, setLimitFilter] = useState(20);
  const [data, setData] = useState([]);
  const [incomeLiveRate, setIncomeLiveRate] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [paymentTransaction, setPaymentTransaction] = useState([]);
  const incomeData = useSelector((state) => state.incomeData.incomeWallet);
  const [currentIncome, setCurrentIncome] = useState("");
  const [companyData, setCompanyData] = useState([]);
  const [filterVisibility, setFilterVisibility] = useState(false);
  const [dateFilter, setDateFilter] = useState("default");
  const [search, setSearch] = useState({
    username: "",
    name: "",
    level: "",
    self_investment: "",
    business: "",
    status: "",
    rank: "",
  });

  const rankNames = [
    { id: 1, name: "BRONZE" },
    { id: 2, name: "SILVER" },
    { id: 3, name: "GOLD" },
    { id: 4, name: "RUBY" },
    { id: 5, name: "SAFIRE" },
    { id: 6, name: "EMERALD" },
    { id: 7, name: "DIAMOND" },
    { id: 8, name: "AMBASSADOR" },
    { id: 9, name: "PRESIDENT" },
    { id: 10, name: "DIRECTOR" },
  ];

  const incomeWallets = [
    { slug: "topLeg", name: "Team A" },
    { slug: "secondTopLeg", name: "Team B" },
    { slug: "otherLeg", name: "Team C" },
  ];
  const [selectIncome, setSelectIncome] = useState(incomeWallets[0]?.slug);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setSearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
  };
  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };
  const resetData = () => {
    setSearch({
      username: "",
      name: "",
      level: "",
      self_investment: "",
      business: "",
      status: "",
      rank: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);
    fetchHistory(true);
  };
  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  var x = 0;
  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (x === 0) {
      fetchHistory();
      // fetchIncome();
      CompanyInfo();
      x++;
    }
  }, [selectIncome || incomeWallets[0]?.slug, currentPage]);

  async function CompanyInfo() {
    try {
      const data = localStorage.getItem("companyData");
      console.log("data", data);
      setCompanyData(JSON.parse(data));
    } catch (error) {
      BasicInfo.isDebug && console.log(error);
    }
  }

  // async function fetchIncome() {
  //   const res = await AxiosGet(ApiPaths.getWallets);
  //   if (res) {
  //     dispatch(setIncomeWallet(res?.wallets));
  //   }
  // }
  async function fetchHistory(isReset = false) {
    console.log("selectIncome", selectIncome);
    console.log("startDate", startDate);
    console.log("endDate", endDate);
    isReset = isReset == true ?? false;
    try {
      setLoading(true);
      const filters = {
        source: selectIncome == "" ? incomeWallets[0]?.slug : selectIncome,
      };
      BasicInfo.isDebug && console.log(filters, "filters");
      const queryParams = {
        page: currentPage,
        limit: limitFilter,
        teamType: selectIncome,
        ...filters,
      };

      if (isReset == false) {
        if (startDate) {
          queryParams.startDate = startDate;
        }
        if (endDate) {
          queryParams.endDate = endDate;
        }

        // Include other search filters (only if they have values)
        Object.keys(search).forEach((key) => {
          if (search[key]) {
            queryParams[key] = search[key];
          }
        });
      }

      const response = await AxiosGet(
        `${ApiPaths.getTeamBusiness}?${new URLSearchParams(
          queryParams
        ).toString()}`
      );
      console.log("response", response);
      setCurrentIncome(response);
      setPaymentTransaction(response?.selectedTeamUsers || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      BasicInfo.isDebug &&
        console.error("Error fetching payment transactions:", error);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading ? <Loader /> : null}
      <section className="dashboard">
        <div className="incomeTabSelect">
          <IncomeTabs
            incomeWallets={incomeWallets}
            selectIncome={selectIncome}
            setSelectIncome={setSelectIncome}
          />
        </div>
        <div className="incomeSelectBox">
          <button onClick={() => setFilterVisibility(!filterVisibility)}>
            {filterVisibility ? "Hide Filters" : "Show Filters"}
            <i>
              <MdOutlineFilterList />
            </i>
          </button>
          <p style={{ marginRight: "10px" }}>
            Total Business :{" "}
            <span>
              {companyData?.currency_sign}
              {currentIncome?.businessAmount ?? 0}
            </span>
          </p>
        </div>

        {filterVisibility && (
          <section className="filtersection inputPrimary">
            <Row className="gx-2 gy-2">
              <Col lg="2" md="4" xs="12">
                <input
                  type="text"
                  name="username"
                  placeholder="User ID"
                  value={search.username}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={search.name}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="text"
                  name="level"
                  placeholder="Search Level"
                  value={search.level}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="text"
                  name="self_investment"
                  placeholder="Self Business"
                  value={search.self_investment}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4">
                <select
                  name="status"
                  id=""
                  value={search.status}
                  onChange={handleChange}
                >
                  <option value="">--Status--</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </Col>

              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <select
                  name="rank"
                  id=""
                  value={search.rank}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    -- Select Rank --
                  </option>{" "}
                  {/* Default placeholder option 
                  <option value="No Rank">No Rank</option>*/}
                  {rankNames.map((x) => (
                    <option key={x.id} value={x.name}>
                      {x.name}
                    </option>
                  ))}
                </select>
              </Col>
              <Col lg="2" md="4" xs="12">
                <div>
                  <select
                    name="dateFilter"
                    value={dateFilter}
                    onChange={handleDateFilterChange}
                  >
                    <option value="default">Default</option>
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="this_week">This Week</option>
                    <option value="this_month">This Month</option>
                  </select>
                </div>
              </Col>
              <Col lg="2" md="4" xs="12">
                <div>
                  <select
                    name=""
                    value={limitFilter}
                    onChange={handleLimitChange}
                  >
                    <option value="">--All--</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                </div>
              </Col>
              {/* <Col lg="2" md="4" xs="6">
                         <button onClick={handleSearch}>Search</button>
                         </Col> */}
              <Col lg="2" md="4" xs="6">
                <button
                  onClick={fetchHistory}
                  style={{ background: "var(--colorPrimary)", color: "white" }}
                >
                  Search
                </button>
              </Col>
              <Col lg="2" md="4" xs="6">
                <button onClick={resetData}>Reset</button>
              </Col>
            </Row>
          </section>
        )}

        <section className="history">
          {/* <div className="historyContent">
           
          </div> */}
          <div className="table">
            <table>
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>Date Of Joining</th>
                  <th>Date Of Activation</th>
                  <th>User ID</th>
                  <th>Profile Name</th>
                  <th>Direct Team</th>
                  <th>Direct Business ({companyData?.currency_sign})</th>
                  <th>Rank</th>
                  <th>Level</th>
                  <th>Sponsor</th>
                  <th>Self Package ({companyData?.currency_sign})</th>
                  <th>Team Business ({companyData?.currency_sign})</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {paymentTransaction?.map((x, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1 + limitFilter * (currentPage - 1)}</td>
                      <td>{moment(x?.joining_date).format("lll")}</td>
                      <td>
                        {x?.activation_date
                          ? moment(x?.activation_date).format("lll")
                          : "---"}
                      </td>
                      <td>{x?.username}</td>
                      <td>{x?.name}</td>
                      <td>{x?.directTeam}</td>
                      <td>{x?.directBusiness}</td>
                      <td>{x?.rank}</td>
                      <td>{x?.level}</td>
                      <td>{x?.sponsorUsername}</td>
                      <td>{x?.selfPackage}</td>
                      <td>{x?.teamBusiness}</td>
                      {x?.status == "1" ? (
                        <td style={{ color: "var(--colorSuccess)" }}>Active</td>
                      ) : (
                        <td>Inactive</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {paymentTransaction.length === 0 && <p>No history yet</p>}
          </div>
          {paymentTransaction != null && (
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePagination}
            />
          )}
        </section>
      </section>
    </>
  );
};

export default LegBusiness;
